"use strict";
/*
 * Created on Tue Jun 18 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var DashboardTaskConverter_1 = require("./conversions/DashboardTaskConverter");

var DashboardTaskConverterImpl_1 = require("./conversions/DashboardTaskConverterImpl");
/**
 * Configures dashboard task app module.
 *
 * @author Jaroslav Sevcik
 */


var DashboardTaskAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(DashboardTaskAppModule, _AppModule_1$AppModul);

  function DashboardTaskAppModule() {
    var _this;

    _classCallCheck(this, DashboardTaskAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DashboardTaskAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'dashboardTaskAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(DashboardTaskAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(DashboardTaskConverter_1.DashboardTaskConverter).to(DashboardTaskConverterImpl_1.DashboardTaskConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return DashboardTaskAppModule;
}(AppModule_1.AppModule);

exports.DashboardTaskAppModule = DashboardTaskAppModule;